import { P2GBox, P2GFade, P2GProgress } from '@parcel2go/core-ui';
import { lazy, Suspense } from 'react';
import { SidePanelSectionTitle } from '../sidepanel-section';
const LazyCmsContent = lazy(() => import('../content/cms-content'));

export interface IP2GImageMessageProps {
  image?: string;
  message?: string;
  contentKey?: string;
  showLoader?: boolean;
  textAlign?: 'left' | 'center' | 'right';
  spacer?: boolean;
}

/* Remove image prop and use content key. TODO */
export const P2GImageMessage: React.FC<React.PropsWithChildren<IP2GImageMessageProps>> = (props) => {
  return (
    <P2GFade in>
      <P2GBox textAlign={props.textAlign ?? 'center'} flexDirection="column" display="flex" gap={2}>
        <Suspense>
          <LazyCmsContent
            contentKey={props.contentKey ?? ''}
            wrapper={(c) => (
              <P2GFade in timeout={800}>
                <P2GBox textAlign="center">{c}</P2GBox>
              </P2GFade>
            )}
          >
            {props.spacer != false && <P2GBox p={2} />}
          </LazyCmsContent>
        </Suspense>
        {props.message && (
          <P2GFade in timeout={800}>
            <P2GBox textAlign="center">
              <SidePanelSectionTitle title={props.message} />
            </P2GBox>
          </P2GFade>
        )}
        {props.children && (
          <P2GFade in timeout={800}>
            <P2GBox>{props.children}</P2GBox>
          </P2GFade>
        )}
        {props.showLoader && (
          <P2GFade in timeout={800}>
            <P2GProgress />
          </P2GFade>
        )}
      </P2GBox>
    </P2GFade>
  );
};
